import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import urlBase from '../../url-base';
import axios from 'axios';
import MenuNew from '../MenuNew';
import Modal from 'react-responsive-modal';
import NavbarDrop from './NavbarDrop';
import {
  Container, Row, Col, //FormGroup, Input
} from 'reactstrap';

class PurchasePlan extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modalApp:false,
      dispositivo:null,
      appdental: false,
      visibilitySensor: true,
      options: false,
      //cities: [],
      urlBackgroundImage: '',
      //modalOpen: false,
      dropdownOpen: false,
      expanded: "false",
    };

  }

  componentDidMount() {
    this.detectar_mobile();
    /* if (sessionStorage.getItem('select_cities') == null){
      this.openModal();
    }

    axios.get(urlBase.loopBack + "Cities")
    .then((response) => {
      let state = this.state;
      state.// = response.data;
      this.setState(state);

      if (sessionStorage.getItem('select_cities') != null)
        document.getElementById('i_select_cities').value = sessionStorage.getItem('select_cities');
    })
    .catch(function () {

    }); */

    if (this.props.admin == false) {
      // Pega e seta a imagem do topo
      this.getBackgroundImage();
    }
  }
  detectar_mobile(){ 
    let state = this.state;
    if(navigator.userAgent.match(/Android/i)){
      state.dispositivo = "android";
    }
    if(navigator.userAgent.match(/iPhone/i)){
      state.dispositivo = "iphone";
    }
    this.setState(state);
  }
  modalAppOn(){
    let state = this.state;
    state.modalApp = true;
    this.setState(state);
  }
  modalAppOff(){
    let state = this.state;
    state.modalApp = false;
    this.setState(state);
  }
  getBackgroundImage() {
    axios.get(urlBase.loopBack + 'attachments/image_top_site/files')
    .then((result) => {
      let state = this.state;
      state.urlBackgroundImage = urlBase.loopBack + 'attachments/image_top_site/download/'+result.data[0].name;
      this.setState(state);
    })
    .catch(function () {
      /* console.log(erro); */
    });
  }

  onChangeVisibilitySensor(isVisible) {
    let state = this.state;
    if(sessionStorage.getItem('app_dental') != null){
      state.appdental = false;
    }else{
      state.appdental = true;
    }
    state.visibilitySensor = isVisible;
    this.setState(state);
  }

  // Chama uma função caso o form esteja sendo exibido na parte admin
  checkSalesmanAdminForm() {
    // No admin
    if (this.props.checkSalesmanFn != null) {
      this.props.checkSalesmanFn();
    }
    else 
      location.href = urlBase.client + "foryouandyourfamily";
  }

  /* onChangeCities () {
    if (document.getElementById('i_select_cities').value == '-1'){
      sessionStorage.setItem('select_cities', null);
      this.closeModal();
    }
    else{
      sessionStorage.setItem('select_cities', document.getElementById('i_select_cities').value);
      this.closeModal();
    }  
  } */

  /* checkCities() {
    if (sessionStorage.getItem('select_cities') == null){
      alert('Escolha uma cidade antes de continuar');
    }else {
      if (this.props.onClickFn != null)
        this.props.onClickFn();
      else
        location.href = urlBase.client + "foryouandyourfamily";
    }
  } */

  /* toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  } */

  /* openModal() {
    let state = this.state;
    state.// = true;
    this.setState(state);
  } */
  /* closeModal() {
    let state = this.state;
    state.// = false;
    this.setState(state);
  } */
  close(){
    let state = this.state;
    sessionStorage.setItem('app_dental', "true");
    state.visibilitySensor = true;
    this.setState(state);
  }


  render() {
    const VisibilitySensor = require('react-visibility-sensor');
    return (
      <div id="component_purchase_plan">

        {this.props.admin == false ? (
        <div>
          <div>
            <VisibilitySensor partialVisibility={true} onChange={this.onChangeVisibilitySensor.bind(this)}>
              <MenuNew />
            </VisibilitySensor>
          </div>    
        </div>
          ) : ('')
        }
        
				{this.props.admin == false ? (
        <div>
          {this.state.visibilitySensor == false ? (
            this.state.appdental == true ? (
              <div id="scroll" className="scroll-down">
                <Row>
                  {this.state.dispositivo == null ? (
                    <Col onClick={this.modalAppOn.bind(this)} className="text-scroll">BAIXE O APLICATIVO DA DENTAL CENTER</Col>
                  ):(
                    this.state.dispositivo == "android" ? (
                      <Link href="https://play.google.com/store/apps/details?id=br.com.planodentalcenter" target="_blank">
                        <Col className="text-scroll">BAIXE O APLICATIVO DA DENTAL CENTER</Col>
                      </Link>
                    ):(
                      <Link href="https://itunes.apple.com/br/app/dentalcenter-associado/id1281072501?mt=8" target="_blank">
                        <Col className="text-scroll">BAIXE O APLICATIVO DA DENTAL CENTER</Col>
                      </Link>
                    )
                  )}
                  <Col className="icon-scroll" ><i onClick={this.close.bind(this)}className="fas fa-times-circle color_fa">{''}</i></Col>
                </Row>
              </div>
            ):('')
          ):('')}
          <Modal
            open={this.state.modalApp} onClose={this.modalAppOff.bind(this)}
            center showCloseIcon={false}
            classNames={{ modal: 'custom_app_modal'}}
          >
            <div>
              
              <Row style={{marginBottom:45, paddingLeft:15}}>
                <Col>  
                  <div className="logo">&nbsp;</div>
                </Col>
                <Col className="icon_app_modal_dental">
                  <i onClick={this.modalAppOff.bind(this)} className="fas fa-times-circle color_fa">{''}</i>
                </Col>
              </Row>
              <p className="app_text">ESCOLHA A LOJA</p>
              <Row>
                <Col>
                  <Link href="https://play.google.com/store/apps/details?id=br.com.planodentalcenter" target="_blank">
                    <div className="androidapp">{""}</div>
                  </Link>
                </Col>
                <Col>
                  <Link href="https://itunes.apple.com/br/app/dentalcenter-associado/id1281072501?mt=8" target="_blank">
                    <div className="appstore">{""}</div>
                  </Link>
                </Col>
              </Row>
            </div>
          </Modal>
          {/*************************** CIDADE ***************************/}
          {/* <Modal
            open={this.state.//} onClose={this.openModal.bind(this)}
            center showCloseIcon={false}
            classNames={{ modal: 'custom-modal-parcial' }}
          >
            <div id="formgroup_select" >  
              <Container style={{marginTop:10}}>
                <Row style={{marginBottom:45, paddingLeft:15}}>
                  <div className="logo">&nbsp;</div>
                </Row>
                <p className="text-modal">
                  PARA CONHECER NOSSOS SERVIÇOS,
                  INFORME A SUA CIDADE
                </p>
                <Row>
                  <Col>
                    <div id="choose_city" className="acrylic">
                      <FormGroup id="arrow"  style={{margin:0, textAlign:'center'}}>
                        <Input
                          id="i_select_cities"
                          style={{width: '100%', maxHeight:60}}
                          type="select"
                          name="select"
                          onChange={this.onChangeCities.bind(this)}
                        >
                          <option className="options_custom" value={-1} >ESCOLHA UMA CIDADE</option>
                          {this.state.//.map(item =>
                            <option className="options_custom" key={item.id} value={item.id}>{item.name}</option>
                          )}
                        </Input>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Modal> */}
          {/*************************** NAVBAR DROPDOWN **************************/}
          <NavbarDrop/>
        </div>
          ) : (
        <div>
          {/* <Row>
            <Col>
              <div id="choose_city" className="acrylic" style={{marginBottom:40, maxWidth:'60%', margin:'auto'}}>
                <FormGroup id="arrow"  style={{margin:0, textAlign:'center'}}>
                  <Input
                    id="i_select_cities"
                    style={{width: '100%', maxHeight:60}}
                    type="select"
                    name="select"
                    onChange={this.onChangeCities.bind(this)}
                  >
                    <option id="options" value={-1} >ESCOLHA UMA CIDADE</option>
                    {this.state.//.map(item =>
                      <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                  </Input>
                </FormGroup>
              </div>
            </Col>
          </Row> */}
        </div>
          )
        }	
        
			{/*************************** PLANOS **************************/}
			<Container id="purchase_plan">
				<Row>
					<Col xs="12" sm="12" md="12" lg="6" style={{paddingRight: 0, paddingLeft: 0}}>
            <Link
              //onClick={this.checkSalesmanAdminForm.bind(this)}
              //to={urlBase.client + "foryouandyourfamily"}
              style={{cursor:'pointer'}}
            >
              <div className="plan_1">
                <div className="plan_text" style={{marginTop:150}}>
                  <div className="content_plan">
                    <p className="plan_text_plan">PLANOS</p>
                    <p className="plan_pra_voce">PRA VOCÊ</p>
                    <p className=" plan_text_small">E SUA FAMÍLIA</p>
                  </div>

                </div>
              </div>
            </Link>
					</Col>
					<Col xs="12" sm="12" md="12" lg="6" style={{paddingRight: 0, paddingLeft: 0}}>
            <Link to="parasuaempresa">
              <div className="plan_2">
                <div className="plan_text plan_text" style={{marginTop:150}}>
                  <div className="content_plan2">
                    <p className="plan_text_plan2">PLANOS</p>
                    <p className="plan_text_small plan_pra_sua">PRA A SUA</p>
                    <p className="plan_pra_voce plan_text_empresa">EMPRESA</p>
                  </div>
                </div>
              </div>
            </Link>
					</Col>							
				</Row>
			</Container>
        {/*************************** PLANOS **************************
          <Container id="plans_container">
            <Row>
              <Col className="plans_container_col" xs="6" sm="6" md="6" lg="6">
                <Link onClick={this.checkCities.bind(this)} style={{cursor:'pointer'}}>
                  <div className="plans_content acrylic hvr-bounce-to-right">
                    <div id="icon_family">&nbsp;</div>
                    <p className="font_light p1">PRA VOCÊ</p>
                    <p className="font_bold p2">E SUA FAMÍLIA</p>
                    <Button id="button_family" outline size="lg">ADQUIRIR</Button>{' '}
                  </div>
                </Link>
              </Col>

              <Col className="plans_container_col" xs="6" sm="6" md="6" lg="6">
                <Link to="foryourcompany">
                  <div className="plans_content acrylic hvr-bounce-to-right">
                    <div id="icon_empresa">&nbsp;</div>
                    <p className="font_light p1">PRA SUA</p>
                    <p className="font_bold p2">EMPRESA</p>
                    <Button id="button_empresa" outline size="lg">ADQUIRIR</Button>{' '}
                  </div>
                </Link>
              </Col>
            </Row>
          </Container>*/}
        
      </div>
    );
  }

}

PurchasePlan.defaultProps = {
  admin: false,
  checkSalesmanFn: null
};

PurchasePlan.propTypes = {
  admin: PropTypes.bool,
  checkSalesmanFn: PropTypes.func
};

export default PurchasePlan;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/PurchasePlan.js
 **/